import { render, staticRenderFns } from "./InputsRectangleTypeMask.vue?vue&type=template&id=243239ea"
import script from "./InputsRectangleTypeMask.vue?vue&type=script&lang=js"
export * from "./InputsRectangleTypeMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243239ea')) {
      api.createRecord('243239ea', component.options)
    } else {
      api.reload('243239ea', component.options)
    }
    module.hot.accept("./InputsRectangleTypeMask.vue?vue&type=template&id=243239ea", function () {
      api.rerender('243239ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/mask-settings-components/InputsRectangleTypeMask.vue"
export default component.exports